export const getTeams = state => state.teams.list;
export const getTeamsForClub = state => state.clubTeams.list;
export const getTeamById = (state, id) => state.teams.list.find(team => team.id === id);
export const getTeamByID = id => state => state.teams.list_MODERN[id];
export const getStatusByID = id => state => state.teams.status[id];
export const getDivisions = state => state.teams.divisions;
export const getTeamStatusById = (state, id) => state.teams.status[id];
